<template>
 <div v-loading="loading" class="content-two">
  <div class="img_content" v-infinite-scroll="load">
    <div class="img_item" v-for="(item, index) in imgList" :key="index">
      <img
        alt=""
        :src="item.imageUri + '?x-oss-process=style/log_list_thumb'"
        @click="lookImg(item.imageUri)"
      />
      <div class="dec">
        <div>
          <span>{{ item.userName }}</span>
          <span class="school">{{ item.universityName }}</span>
        </div>
        <img
          v-if="item.login"
          alt=""
          :src="item.login + '?x-oss-process=style/log_list_thumb'"
        />
      </div>
    </div>
    <div class="shade_pop animate__animated animate__fadeIn" v-if="modal"></div>
    <div class="log_modal" v-if="logModal">
      <img
        class="log_close"
        src="https://univteam-imageserver.oss-cn-qingdao.aliyuncs.com/ClassMS/Images/202110291045042331.svg"
        alt=""
        @click="closeLog"
      />
      <el-image class="look_img" :src="look_img" :fit="contain"></el-image>
    </div>
  </div>
   </div>
</template>

<script>
export default {
  data() {
    return {
      modal: false,
      logModal: false,
      look_img: "",
      imgList: [],
      id: "",
      tagId: "",
      count: 1,
      loading: false,
    };
  },
  created() {
    this.id = this.$route.query.ppcId;
    this.tagId = this.$route.query.tagId;
    this.getImgList();
  },
  methods: {
    load() {
        this.loading = true;
        setTimeout(() => {
          this.count += 1; //页数+1
          this.getImgList(); //调用接口，此时页数+1，查询下一页数据
        }, 2000);
    },
    //图片数据请求
    getImgList() {
      var data = {
        pageSize: 15,
        pageIndex: this.count,
        id: this.id,
        tagId: this.tagId,
      };
      this.$api.social.getLogImage(data).then((res) => {
        this.loading = false;
        if (res.data.length > 0) {
          this.imgList = this.imgList.concat(res.data);
        }
      });
    },
    closeLog() {
      this.modal = false;
      this.logModal = false;
    },
    lookImg(item) {
      this.logModal = true;
      this.modal = true;
      this.look_img = item;
    },
  },
};
</script>

<style lang="scss" scoped>
.img_content {
  width: 100%;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: space-between;
  max-height: 800px;
  overflow-y: auto;
  padding-right: 10px;
  .img_item {
    width: 300px;
    height: 334px;
    position: relative;
    cursor: pointer;
    overflow: hidden;
    margin-bottom: 21px;
    border-radius: 5px;
    img {
      width: 100%;
      object-fit: cover;
      height: 100%;
    }
    .dec {
      position: absolute;
      bottom: 0px;
      height: 35px;
      width: 100%;
      background: linear-gradient(rgba(50, 54, 70, 0), rgba(28, 31, 48, 1));
      display: flex;
      align-items: center;
      color: #ffffff;
      font-size: 14px;
      justify-content: space-between;
      padding: 0 10px;
      .school {
        margin-left: 8px;
      }
      img {
        border-radius: 50%;
        width: 26px;
        height: 26px;
      }
    }
  }
  .img_item:nth-last-of-type(-n + 3) {
    margin-bottom: 0;
  }
}
.shade_pop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1000;
}
.log_modal {
  width: 860px;
  // height: 710px;
  border-radius: 10px;
  position: fixed;
  top: 13%;
  left: 50%;
  margin-left: -500px;
  // margin-top: -355px;
  background: #fff;
  z-index: 1001;
  padding: 20px;
  .log_close {
    width: 40px;
    position: absolute;
    top: -60px;
    right: 20px;
    cursor: pointer;
  }
  .look_img {
    width: 100%;
    height: 100%;
    overflow-y: scroll;
    max-height: 800px;
  }
}

</style>